import { HomeworkSolution } from 'src/api/endpoints/homeworks/api'
import { HomeworkCard } from '../components/HomeworkCard'
import { ReactElement } from 'react'
import { map } from 'lodash'

export type HomeworkClickEventHandler = (homework: HomeworkSolution) => void;

export type GetHomeworkCardComponentsParams = {
    homeworks: HomeworkSolution[];
    onHomeworkClick: HomeworkClickEventHandler;
};

export type GetHomeworkCardComponentParams = {
    homework: HomeworkSolution;
    onHomeworkClick: HomeworkClickEventHandler;
};

export const getHomeworkCardComponents = (params: GetHomeworkCardComponentsParams) => {
    const { homeworks, onHomeworkClick } = params
    
    return map(
        homeworks,
        (homework: HomeworkSolution): ReactElement =>
            getHomeworkCardComponent({
                homework,
                onHomeworkClick,
            }),
    )
}

export const getHomeworkCardComponent =
    (params: GetHomeworkCardComponentParams): ReactElement => {
        const { homework, onHomeworkClick } = params
        
        const onClick: () => void = (): void => onHomeworkClick(homework)
        
        return (
            <div
                key={homework.userId}
                className={
                    'col-12 md:col-6 lg:col-4'
                }
            >
                <HomeworkCard
                    key={homework.homeworkId}
                    date={homework.uploadedAt}
                    avatar={homework.avatar}
                    fullname={homework.fullname}
                    status={homework.status}
                    mark={homework.mark}
                    statusText={homework.status}
                    onClick={onClick}
                />
            </div>
        )
    }